import { render, staticRenderFns } from "./EarthDayHero.vue?vue&type=template&id=1ef63f0a&"
import script from "./EarthDayHero.vue?vue&type=script&lang=js&"
export * from "./EarthDayHero.vue?vue&type=script&lang=js&"
import style0 from "./EarthDayHero.vue?vue&type=style&index=0&id=1ef63f0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CartCountdownAltAuto: require('/opt/build/repo/components/Cart/CountdownAltAuto.vue').default})
